export enum WorkTypeEnum {
  'Акт проверки',
  'Метрологическая экспертиза',
  'Методика измерений',
}
